import registerApiHandlers from "../api";
import { registerMediaHandlers } from "./media";
import { registerSessionHandlers } from "./session";

export const registerAmazonConnectEvents = () => {
    // Listen to connect api events
    registerSessionHandlers();
    registerApiHandlers();
    registerMediaHandlers();
}